import axios from 'axios'

export default {
  getUnloadingLocations() {
    return axios.get('GetUnloadingLocations')
  },
  getEstablishments() {
    return axios.get('GetEstablishmentsForPurchaseOrder')
  },
  async getPurchaseOrders(page, ponId, search) {
    const params = {
      page,
      ponId,
      size: 15,
      search,
    }
    try {
      const response = await axios.get('GetPurchaseOrders', { params })
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getPurchaseOrder(purchaseOrderId) {
    const params = {
      purchaseOrderId,
    }
    try {
      const response = await axios.get('GetPurchaseOrder', { params })
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async createPurchaseOrder(purchaseOrder) {
    try {
      const response = await axios.post('CreatePurchaseOrder', purchaseOrder.Details)
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async updatePurchaseOrder(purchaseOrder, ponId) {
    try {
      const queryString = ponId ? `&ponId=${ponId}` : ''
      const response = await axios.put(
        `UpdatePurchaseOrder?purchaseOrderId=${purchaseOrder.PurchaseOrderId}${queryString}`,
        purchaseOrder.Details
      )
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async requestPurchaseOrder(purchaseOrder, ponId) {
    try {
      const queryString = ponId ? `&ponId=${ponId}` : ''

      const response = await axios.post(
        `RequestPurchaseOrder?purchaseOrderId=${purchaseOrder.PurchaseOrderId}${queryString}`,
        purchaseOrder.Details
      )
      return response.data
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async deletePurchaseOrder(purchaseOrderId, ponId) {
    const params = {
      purchaseOrderId,
      ponId,
    }
    try {
      return await axios.delete('DeletePurchaseOrder', { params })
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async downloadKomNumbers(purchaseOrderId) {
    const params = {
      purchaseOrderId,
    }
    try {
      const response = await axios.get('DownloadPurchaseOrderKomNumbers', {
        params,
      })
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async getPurchaseOrderProgress(purchaseOrderId, transactionId) {
    const params = {
      purchaseOrderId,
      transactionId,
    }
    try {
      const response = await axios.get('GetPurchaseOrderProgress', {
        params,
      })
      return Promise.resolve(response.data)
    } catch (e) {
      return Promise.reject(e)
    }
  },
}
